import { Select } from '@mantine/core';

import { Platforms } from '@/types';

type Props = {
  label: string;
  enabledAll?: boolean;
  value?: Platforms | 'all';
  onSelect: (value: Platforms) => any;
};

const baseData = [
  { value: Platforms.telegram, label: 'Telegram' },
  { value: Platforms.instagram, label: 'Instagram' },
];

export const PlatformsSelect = ({ label, value, enabledAll, onSelect }: Props) => {
  const data = enabledAll ? [{ value: 'all', label: 'All' }, ...baseData] : baseData;

  const values = data.map((item) => item.value);

  return (
    <Select
      label={label}
      value={value}
      data={data}
      onChange={(value) => {
        if (value && values.includes(value as any)) {
          onSelect(value as Platforms);
        }
      }}
    />
  );
};
